var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import RadioButton from '@frontend-components/components/RadioButton';
import Button from '@frontend-components/components/Button';
import { getGlobalState } from '../../Utils/GlobalState';
import T from '../../Utils/Locale';
import { nonePartnerId } from './constants';
const PartnersSessionKey = 'partners-data';
const applicationUrl = getGlobalState('application_url');
const itemClasses = 'partners-wrapper-list-item flex justify-between items-center px-4 py-3 mb-3';
const AuthenticationPartnerSelect = ({ onClickNext }) => {
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [partners, setPartners] = useState([]);
    useEffect(() => {
        fetchPartners();
    }, []);
    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: 'tailwind-reset text-dark-teal text-sm mb-6' }, { children: T('authentication.partner.text') })), _jsxs("div", Object.assign({ className: 'overflow-auto' }, { children: [_jsxs("div", Object.assign({ className: itemClasses, onClick: () => setSelectedPartner('none'), "data-testid": `partner-radio-${nonePartnerId}` }, { children: [_jsx("p", { children: T('authentication.partner.none') }), _jsx(RadioButton, { value: nonePartnerId, name: 'partner-name', checked: selectedPartner === nonePartnerId, handleOnChange: setSelectedPartner })] })), partners.map((partner) => (_jsxs("div", Object.assign({ className: itemClasses, onClick: () => setSelectedPartner(partner.id), "data-testid": `partner-radio-${partner.id}` }, { children: [_jsx("img", { className: 'partners-wrapper-list-item-logo', src: partner.logoFullPath, alt: partner.id }), _jsx(RadioButton, { value: partner.id, checked: selectedPartner === partner.id, handleOnChange: setSelectedPartner, name: 'partner-name' })] }), partner.id)))] })), _jsx("div", Object.assign({ className: 'flex justify-center mt-4 mb-6' }, { children: _jsx(Button, Object.assign({ size: 'fluid', onClick: handleCLickNext, id: 'submit-partner', disabled: selectedPartner == null }, { children: T('authentication.partner.next') })) }))] }));
    function fetchPartners() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const sessionPartners = window.sessionStorage.getItem(PartnersSessionKey);
                if (sessionPartners != null) {
                    setPartners(JSON.parse(sessionPartners));
                    return;
                }
                const { data } = yield axios.get(`${applicationUrl}/api/partners?priority=1`, { withCredentials: true });
                setPartners(data);
                window.sessionStorage.setItem(PartnersSessionKey, JSON.stringify(data));
            }
            catch (error) {
                console.error(error, ' Failed to fetch partners list');
            }
        });
    }
    function handleCLickNext() {
        if (selectedPartner !== nonePartnerId) {
            window.location.href = `https://henvisning.testaviva.dk/${selectedPartner}?advisor=0`;
            return;
        }
        onClickNext();
    }
};
AuthenticationPartnerSelect.propTypes = { onClickNext: PropTypes.func.isRequired };
export default AuthenticationPartnerSelect;
